import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-params',
  templateUrl: './admin-params.component.html',
  styleUrls: ['./admin-params.component.css']
})
export class AdminParamsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
